module.exports = __webpack_public_path__ + "75f541c78ccbee5bbd16cdfbd0acdf38.svg";